<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 11.8774C3 13.2582 4.11929 14.3774 5.5 14.3774C6.88071 14.3774 8 13.2582 8 11.8774C8 10.4967 6.88071 9.37744 5.5 9.37744C4.11929 9.37744 3 10.4967 3 11.8774Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 4.87744C16 6.25815 17.1193 7.37744 18.5 7.37744C19.8807 7.37744 21 6.25815 21 4.87744C21 3.49673 19.8807 2.37744 18.5 2.37744C17.1193 2.37744 16 3.49673 16 4.87744Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 19.1224C16 20.5031 17.1193 21.6224 18.5 21.6224C19.8807 21.6224 21 20.5031 21 19.1224C21 17.7417 19.8807 16.6224 18.5 16.6224C17.1193 16.6224 16 17.7417 16 19.1224Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.16113 10.982L15.962 5.50244"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.16113 13.239L15.962 18.7186"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
